export default "__VITE_ASSET___k9HnMFg__"